
import { Injectable } from '@angular/core';

// Application specific configuration
@Injectable()
export class ConfigService {
    // TODO is this still needed?
}
